/* Just used for passing args to the Create Sweep page for now */
import {type ActionType as TSActionType, getType} from 'typesafe-actions';

// eslint-disable-next-line import/no-cycle -- please fix if you can
import type * as Sweeps from '../../util/sweeps';
import {immerReducer} from '../reducer';
import * as Actions from './actions';

export interface StateType {
  createSweepArgs?: Sweeps.CreateSweepArgs;
}

export type ActionType = TSActionType<typeof Actions>;

function sweepsReducer(state: StateType, action: ActionType) {
  switch (action.type) {
    case getType(Actions.clearCreateSweepArgs):
      state.createSweepArgs = undefined;
      break;
    case getType(Actions.setCreateSweepArgs):
      const {runSet, tempSelections} = action.payload.createSweepArgs;
      state.createSweepArgs = {
        runSet: {
          ...runSet,
          pinnedRunIds: [],
          baselineRunId: undefined,
        },
        tempSelections,
      };
      break;
  }
}

export default immerReducer<StateType, ActionType>(sweepsReducer, {});
